'use strict';

/**
 * Changes from base:
 * 1. Added Alert for emails
 * 2. Added OTP generation and validation logic
 */

var base = require('base/contactUs/contactUs');

var STATUS = {
    SUCCESS: 'success',
    ERROR: 'error'
}

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    var feedbackStatus;
    if (data.success || data.success === undefined && !data.error) {
        status = 'alert-success';
        feedbackStatus = STATUS.SUCCESS;
    } else {
        status = 'alert-danger';
        feedbackStatus = STATUS.ERROR;
    }

    $.alert(data.msg, feedbackStatus, false);

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Handle OTP generation and validation
 */
function handleOTP() {

    // 1. Generate OTP
    $('#generate-otp').on('click', function (e) {
        e.preventDefault();

        var form = $(this).closest('form')[0];

        // 1. Trigger validation
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        var email = $('#contact-email').val();
        var button = $(this);

        if (!email) {
            return;
        }

        button.attr('disabled', true);
        $.spinner().start();

        $.ajax({
            url: button.data('action-url'),
            type: 'post',
            data: { otpID: email },
            success: function (response) {
                displayMessage(response, button);
                if (response.success) {
                    $('.contact-us-otp-verify').removeClass('is-hidden');
                }
            },
            error: function () {
                displayMessage({ success: false });
            }
        });
    });

    // 2. Validate OTP
    $('#validate-otp').on('click', function () {
        var email = $('#contact-email').val();
        var otp = $('#contact-otp').val();

        if (!email || !otp) {
            displayMessage({ success: false});
            return;
        }

        var button = $(this);
        button.attr('disabled', true);
        $.spinner().start();

        $.ajax({
            url: button.data('action-url'),
            type: 'post',
            data: { otpID: email, otpValue: otp },
            success: function (response) {
                displayMessage(response, button);
                if (response.success) {
                    $('form.contact-us').submit();
                    $('.contact-us-otp-verify').addClass('is-hidden');
                }
            },
            error: function () {
                displayMessage({ success: false});
            }
        });
    });
}

module.exports = base;

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    displayMessage(data, button);
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });

        // Initialize OTP handling
        handleOTP();
    }
};